import { Button, ButtonProps, styled } from "@mui/material";

export const EntityTableToolbarButton = styled(Button)(({ theme }) => ({
	color: theme.palette.primary.contrastText,
}));
